export enum CallRefinementStatus {
  Idle = 'IDLE',
  Thinking = 'THINKING',
  Updated = 'UPDATED',
  /** Content can't be auto-refined further (e.g. manually overridden) —
   * rendered as a dismissible banner. Distinct from Error, which is a
   * failed refinement attempt. Nothing currently maps a server status to
   * this — it's ready for a future caller to set it explicitly. */
  Warning = 'WARNING',
  Error = 'ERROR',
  /** Refinement failed because the request is outside what refinement can
   * control (e.g. scoring, pronunciation). Shown as a distinct message
   * directing the author to contact support, rather than "try again". Only
   * reachable via SSE — polling fallback always resolves to Error. */
  OutOfScope = 'OUT_OF_SCOPE',
}
